module.exports = __webpack_public_path__ + "static/media/GroupTruckDisabled.24847ca7.svg";